import React from 'react';
import { Row, Col, Button } from "reactstrap";
import { formatNullableValue } from '../../../../utils/formatar';
 import { IconeSetaDescer, IconeSetaSubir } from '../../../comum/components/Icones';
// import NumberFormat from 'react-number-format';
// import { calendarFormat } from 'moment';


export default class CardAgendamento extends React.Component {

    constructor(props) {
        super(props);
    }

    addAcaoCancelar(id){
        return(
            <Button onClick={() => this.props.cancelAction(id)}>
                Cancelar
            </Button>
        )

    }

    render() {

        return (
            <Col xs={12} md={6} lg={4} onClick={ this.handleClick }>
                <div className="card-booking">
                    <Row>


                    {this.props.colunas.map((col, x) =>
                       (col.dataField !== "StatusAgendamento") &&
                    //    (col.dataField !== "acoes") &&
                       (<Col xs={col.dataField === "acoes" ? 12 : 6} key={x} className={col.dataField === "acoes" ? "order-last" : ""}>
                            {col.dataField !== "acoes" ?
                                <div className="info bg-cinza">
                                    <div className="titulo">{col.text}</div>
                                    <div className="valor">{ col.formatter ?
                                        formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                                        :
                                        formatNullableValue(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data))
                                        }
                                    </div>
                                </div>
                                :
                                <div className="info">
                                    <div className="titulo">{col.text}</div>
                                    <div className="valor">{col.cardFormatter(null, this.props.data)}</div>
                                </div>
                            }
                        
                        </Col>)
                    )}
                    <Col xs={12}>
                        <div className="info">
                            <div className={`situacao-btn ${ this.props.data.StatusAgendamento.toUpperCase() }`}>{ this.props.data.StatusAgendamento }</div>
                            {/* {col.formatter("booking.Status".split('.').reduce((o,i)=>o[i], this.props.data))} */}
                        </div>
                    </Col>

                    </Row>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-visualizar/components/CardAgendamento.js